import React from "react";
import ReactDOMServer from "react-dom/server";
import { FaBuilding } from "react-icons/fa6";
import { Icon, Style } from "ol/style";

const MARKER_BACKGROUND = "#4F46E5";
const MARKER_FOREGROUND = "#FFFFFF";

function toSvgDataUri(svgMarkup) {
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgMarkup)}`;
}

const fleetLocationMarkerSvg = ReactDOMServer.renderToStaticMarkup(
  <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="fleetMarkerShadow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow dx="0" dy="2" stdDeviation="1.8" floodColor="#111827" floodOpacity="0.35" />
      </filter>
    </defs>
    <circle
      cx="24"
      cy="24"
      r="18"
      fill={MARKER_BACKGROUND}
      stroke={MARKER_FOREGROUND}
      strokeWidth="2"
      filter="url(#fleetMarkerShadow)"
    />
    <g transform="translate(15, 15)">
      <FaBuilding size={18} color={MARKER_FOREGROUND} />
    </g>
  </svg>
);

const fleetLocationMarkerDataUri = toSvgDataUri(fleetLocationMarkerSvg);

export function createFleetLocationMarkerStyle({ scale = 1 } = {}) {
  return new Style({
    image: new Icon({
      src: fleetLocationMarkerDataUri,
      anchor: [0.5, 0.9],
      anchorXUnits: "fraction",
      anchorYUnits: "fraction",
      crossOrigin: "anonymous",
      scale: Math.max(0.4, Number(scale) || 1),
    }),
    zIndex: 12,
  });
}
